/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class ImmortalFruitsSoundConfig implements ISoundConfig {

    public static instance: ImmortalFruitsSoundConfig = new ImmortalFruitsSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE_1: string = "background-music-main";

    MEDIUM_AND_LARGE_WIN: string = "background-music-main2";
    BACKGROUND_MUSIC_BONUS: string = "background-music-bonus";
    // REELS_SPIN_START?:string[];
    SPIN_START_SOUNDS: string[] = ["spinStart1", "spinStart2"];
    REELS_DEFAULT_BOUNCE: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    REELS_SPIN: string[] = ["reelsSpinning1", "reelsSpinning2"];
    // REELS_DEFAULT_STOP?:string[];

    //win sounds
    COUNT_UP: string = "countup";
    COUNT_UP_ENDS: string = "countupEnds";
    public static WIN_LARGE: string = "winLarge";
    public static WIN_MEDIUM: string = "winMedium";
    public static WIN_SMALL: string = "winSmall";
    public BETLINE_SOUND: string = "betline";
    public static WIN_TINY: string = "winTiny";
    // REELS_DEFAULT_STOP?:string[];

    public static BIG_WIN: string = "winBig";
    public static MEGA_WIN: string = "winMega";
    public static SUPER_MEGA_WIN: string = "winSuperMega";
    //scatter
    SCATTER: string = "scatter";
    ANTICIPATION: string = "anticipation";
    ANTICIPATION_FAILS: string = "anticipationFail";

    BONUS_INTRO_WHEEL: string = "bonusIntroWheel";
    BONUS_INTRO_LOGO: string = "bonusIntroLogo";

    //bonusSounds
    BONUSWHEELSPIN: string = "bonusWheelSpin";
    BONUSWHEELFIRE: string = "bonusWheelFire";
    BONUSWHEELLOCK: string = "bonusWheelLock";
    BONUSWHEELLHITONCE: string = "bonusWheelMultiSmall";
    BONUSWHEELLHITBIG: string = "bonusWheelMultiBig";
    BONUSWHEELLHITUP: string = "bonusWheelUp";
    BONUSWHEELOUTROEND: string = "bonusWheelEnds";
    BONUSWHEELMULTUPDATE: string = "bonusWheelMultiUpdate";
    BONUSWHEELGLOW: string = "bonusWheelGlow";
    BONUSWHEELGLOWLOWJACKPITHIT: string = "bonusWheelBlackGlow";
    BONUSWHEELGLOWHIGHJACKPITHIT: string = "bonusWheelBlackGlowJackpot";
    BONUSWHEELGLOW_LEVEL_UP: string = "bonusWheelLevelUpGlow";

    BONUSWHEEL_LEVELUP: string = "bonusWheelLevelUp";
    BW_CONTINUE_BTN: string = "bonusWheelContinueButton";


    //Bigwin sounds
    BIG_WIN_INITIAL_WIN: string = "bigwinInitialWin";
    BIG_WIN_COUNT_UP: string = "bigwinCountup";
    BIG_WIN: string = "bigwin";
    BIG_WIN_LEVEL: string = "bigwinLevel";
    BIG_WIN_ENDS: string = "bigwinEnds";

    WILD_LANDING:string = "wildLanding";

    //Idle Sounds
    IDLE_SWEEP1: string = "idleSweep1";
    IDLE_SWEEP2: string = "idleSweep2";
    IDLE_SWEEP_MULT: string = "idleMulti";

    constructor() {
        if (ImmortalFruitsSoundConfig.instance) {
            throw new Error("ImmortalFruitsSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}